/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Togglesidebar1Inputs */

const he_common_togglesidebar1 = /** @type {(inputs: Common_Togglesidebar1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`החלף סרגל צד`)
};

const en_common_togglesidebar1 = /** @type {(inputs: Common_Togglesidebar1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Toggle Sidebar`)
};

/**
* | output |
* | --- |
* | "Toggle Sidebar" |
*
* @param {Common_Togglesidebar1Inputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
const common_togglesidebar1 = /** @type {((inputs?: Common_Togglesidebar1Inputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Togglesidebar1Inputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_common_togglesidebar1(inputs)
	return en_common_togglesidebar1(inputs)
});
export { common_togglesidebar1 as "common_toggleSidebar" }